// models
import { SyncAnalysis, SyncAnalysisFinding } from '../../models/Entities/Protocols/SyncAnalysis';
import { PaginationState } from '../../models/PaginationState';
import { ErrorType } from '../../models/HttpError';

// Análisis de una corrida de sincronización
export const SYNCANALYSIS_GET_REQUEST = 'SYNCANALYSIS_GET_REQUEST';
export const SYNCANALYSIS_GET_SUCCESS = 'SYNCANALYSIS_GET_SUCCESS';
export const SYNCANALYSIS_GET_FAILURE = 'SYNCANALYSIS_GET_FAILURE';

export interface SyncAnalysisGetRequestAction {
	type: typeof SYNCANALYSIS_GET_REQUEST;
	syncProcessId: string;
}

export interface SyncAnalysisGetSuccessAction {
	type: typeof SYNCANALYSIS_GET_SUCCESS;
	syncProcessId: string;
	// null cuando la corrida todavía no fue analizada.
	analysis: SyncAnalysis | null;
}

export interface SyncAnalysisGetFailureAction {
	type: typeof SYNCANALYSIS_GET_FAILURE;
	syncProcessId: string;
	error: ErrorType;
}

// Hallazgos del análisis
export const SYNCANALYSIS_GETFINDINGS_REQUEST = 'SYNCANALYSIS_GETFINDINGS_REQUEST';
export const SYNCANALYSIS_GETFINDINGS_SUCCESS = 'SYNCANALYSIS_GETFINDINGS_SUCCESS';
export const SYNCANALYSIS_GETFINDINGS_FAILURE = 'SYNCANALYSIS_GETFINDINGS_FAILURE';

export interface SyncAnalysisGetFindingsRequestAction {
	type: typeof SYNCANALYSIS_GETFINDINGS_REQUEST;
	analysisId: string;
}

export interface SyncAnalysisGetFindingsSuccessAction {
	type: typeof SYNCANALYSIS_GETFINDINGS_SUCCESS;
	analysisId: string;
	findings: SyncAnalysisFinding[];
	paginationState: PaginationState;
}

export interface SyncAnalysisGetFindingsFailureAction {
	type: typeof SYNCANALYSIS_GETFINDINGS_FAILURE;
	analysisId: string;
	error: ErrorType;
}
